import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuicktimeComponent } from './simple-icons-quicktime.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuicktimeComponent ],
    exports:      [ SimpleIconsQuicktimeComponent ],
    bootstrap:    []
})
export class SimpleIconsQuicktimeModule {}
